import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pds-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})  
export class TabComponent implements OnInit {

  @Input('tab-label') title: string;
  @Input() active = false;

  constructor() { }

  ngOnInit(): void {
  }

}
